// search-overhaul spec §"Frontend scope" — the composer's Web Search toggle
// is a per-browser preference (default ON) with nowhere per-user server-side
// to live, same posture as memoryPrefs.ts's auto-extract flag and
// chatModel.ts's last-model-selection.
const WEB_SEARCH_KEY = "chatclient.webSearch";

export function loadWebSearch(): boolean {
  try {
    const v = localStorage.getItem(WEB_SEARCH_KEY);
    return v === null ? true : v === "true";
  } catch {
    return true;
  }
}

export function saveWebSearch(value: boolean): void {
  try {
    localStorage.setItem(WEB_SEARCH_KEY, String(value));
  } catch {
    // Storage is a convenience, not a requirement for the current session.
  }
}
